import { useMemo } from 'react';
import { useField } from 'formik';
import { Box, TextField, InputLabel } from '@mui/material';

import { QuestionLabel } from 'components/question-label';
import {
  RadioFormField,
  FormChoiceResponse,
  FormChoiceResponseType,
  FORM_OTHER_OPTION_VALUE,
} from 'types';

import { RadioField } from '../fields';

export const FormRadioField = ({
  id,
  label,
  options,
  required,
}: RadioFormField) => {
  const [field, , helpers] = useField<FormChoiceResponse | null>(id);
  const isOtherSelected = field.value?.type === FormChoiceResponseType.OTHER;
  const controlValue = isOtherSelected
    ? FORM_OTHER_OPTION_VALUE
    : field.value?.value;
  const fieldOptions = useMemo(
    () =>
      options?.options
        ? [
            ...options.options.map((value) => ({ value, label: value })),
            ...(options.allowOther
              ? [{ label: 'Other', value: FORM_OTHER_OPTION_VALUE }]
              : []),
          ]
        : [],
    [options?.options, options?.allowOther]
  );
  return (
    <Box>
      <InputLabel component="div" className="mb-2" required={required}>
        <QuestionLabel value={label} />
      </InputLabel>
      <RadioField
        name={id}
        options={fieldOptions}
        displayValue={controlValue}
        mapValue={(value) =>
          value === FORM_OTHER_OPTION_VALUE
            ? { value: '', type: FormChoiceResponseType.OTHER }
            : { value, type: FormChoiceResponseType.OPTION }
        }
      />
      {options?.allowOther && isOtherSelected && (
        <TextField
          fullWidth
          label="Other"
          className="mt-2"
          value={field.value?.value ?? ''}
          placeholder="Enter another response"
          onChange={(event) => {
            helpers.setValue(
              {
                value: event.target.value,
                type: FormChoiceResponseType.OTHER,
              },
              true
            );
          }}
        />
      )}
    </Box>
  );
};
